const LINKS = {
  NEWSLETTER : {
    id: 'newsletter',
    label: 'Sign up for the Portal newsletter',
    url: 'https://forms.gle/GA2pTNziqFUG9xRS9',
    type: 'tab',
  },
  NVCI: {
    id: 'nvci',
    label: 'New Visions Curriculum and Instruction',
    url: 'https://curriculum.newvisions.org/',
    type: 'tab',
  },
  GET_HELP: {
    id: 'get-help',
    label: 'Get Help',
    type: 'button',
    action: 'reportIssues',
  },
  PRIVACY_POLICY_NYC:{
    id: 'privacy-policy',
    label: 'Privacy and Terms',
    url:  'https://portal.newvisions.org/privacy-policy',
    type: 'tab',
  },
  PRIVACY_POLICY_DISTRICT: {
    id: 'privacy-policy',
    label: 'Privacy and Terms',
    url: 'https://nvportal.org/privacy-policy',
    type: 'tab',
  },
  PRIVACY_POLICY_LANSING:{
    id: 'privacy-policy',
    label: 'Privacy and Terms',
    url:  'https://lansing.nvportal.org/privacy-policy',
    type: 'tab',
  },
  EQUITABLE_OUTCOMES:{
    id: 'equitable-outcomes',
    label: 'Equitable outcomes',
    url: 'https://portal.newvisions.org/equitable-outcomes',
    type: 'tab',
  },
  EQUITABLE_OUTCOMES_DISTRICT: {
    id: 'equitable-outcomes',
    label: 'Equitable outcomes',
    url: 'https://nvportal.org/equitable-outcomes',
    type: 'tab',
  },
}

const SECTIONS = {
  RESOURCES: {
    title: 'Resources',
    links: [
      LINKS.NEWSLETTER, 
      LINKS.NVCI
    ]
  },
  SUPPORT_AND_POLICIES_NYC: {
    title: 'Support and Policies',
    links: [
      LINKS.GET_HELP,
      LINKS.PRIVACY_POLICY_NYC,
      LINKS.EQUITABLE_OUTCOMES
    ]
  },
  SUPPORT_AND_POLICIES_LANSING: {
    title: 'Support and Policies',
    links: [
      LINKS.GET_HELP,
      LINKS.PRIVACY_POLICY_LANSING,
      LINKS.EQUITABLE_OUTCOMES
    ]
  },
  SUPPORT_AND_POLICIES_DISTRICT: {
    title: 'Support and Policies',
    links: [
      LINKS.GET_HELP,
      LINKS.PRIVACY_POLICY_DISTRICT,
      LINKS.EQUITABLE_OUTCOMES_DISTRICT,
    ],
  }
}

export const content = {
  nyc: [
    SECTIONS.RESOURCES,
    SECTIONS.SUPPORT_AND_POLICIES_NYC
  ],
  lansing: [
    SECTIONS.RESOURCES,
    SECTIONS.SUPPORT_AND_POLICIES_LANSING
  ],
  district: [
    SECTIONS.RESOURCES,
    SECTIONS.SUPPORT_AND_POLICIES_DISTRICT,
  ]
}


